/**
 * `/market/disputes` — the arguments about money this account is a side of (R48).
 */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/market/disputes')({});
